import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import CameraEnhanceIcon from "@mui/icons-material/CameraEnhance";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Drawer, List, ListItem } from "@mui/material";
import EditNote from "@mui/icons-material/EditNote";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Snapshot_Icon from "../../../images/snapshots_icon.svg";
import Forms_Icon from "../../../images/forms_icon.svg";
import Reports_Icon from "../../../images/reports_icon.svg";
import Pool from "../../../Userpool";

import "./navbar.css";

const theme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
  },
});

function Navbar({ onArrowBackClick }) {
  const params = useParams();
  const [isDataRequestsPage, setIsDataRequestsPage] = useState(false);
  const [isExternalFormPage, setIsExternalFormPage] = useState(false);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Update isDataRequests state when the location changes
    setIsDataRequestsPage(location.pathname === "/datarequests");
    // Update isExternalFormPage state formId is present
    setIsExternalFormPage(!!params.formId);
  }, [location.pathname]);

  const router = (route) => {
    navigate(route);
  };

  const logout = () => {
    Pool.getCurrentUser().signOut();
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };
  
  let updatedDataArray = null;

  try {
    updatedDataArray = JSON.parse(localStorage.getItem("UpdatedDataArray"));
  } catch (error) {
    alert("error");
    console.error("error", error);
  }

  // Function to navigate back to the current input form
  const goBacktoDataRequestsPage = () => {
    router("/datarequests");
  };

  const timestampStored = localStorage.getItem("timestamp");

  const handleInputFormClick = () => {
    try {
      // Check if the item is disabled
      const isDisabled = !updatedDataArray || updatedDataArray.length === 0;

      if (isDisabled) {
        // Alert will occur if attempt to click
        alert("Please select a snapshot.");
      } else {
        // Navigate to "/inputform" when the item is not disabled
        router("/inputform");
        setOpen(false);
      }
    } catch (error) {
      alert("An error occurred.");
      console.error("Error:", error);
    }
  };

  const handleReportsClick = () => {
    try {
      // Check if the item is disabled
      const isDisabled = !timestampStored;

      if (isDisabled) {
        alert("Please generate a snapshot on the forms page.");
      } else {
        // Navigate to "/reports" when the item is not disabled
        router("/reports");
        setOpen(false);
      }
    } catch (error) {
      alert("An error occurred.");
      console.error("Error:", error);
    }
  };

  const list = () => (
    <div className="nav-container" style={{ width: 250 }}>
      <List>
        <div className="MainMenu">Main Menu</div>
          <>
            {["Report"].map((label, index) => (
              <ListItemButton
                key={index}
                onClick={handleReportsClick}
                className={`nav-item ${!timestampStored ? "disabled" : ""}`}
                disabled={!timestampStored}
              >
                <img src={Reports_Icon} alt="report icon"/>
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
            {["Form"].map((label, index) => (
              <ListItemButton
                key={index}
                onClick={handleInputFormClick}
                className={`nav-item ${
                  !updatedDataArray || updatedDataArray.length === 0
                    ? "disabled"
                    : ""
                }`}
                disabled={!updatedDataArray || updatedDataArray.length === 0}
              >
                <img src={Forms_Icon} alt="edit note icon"/>
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
            {["Snapshots"].map((label, index) => (
              <ListItemButton
                key={index}
                onClick={
                  () => {
                    router("/snapshots")
                    setOpen(false);
                  }}
                className="nav-item"
              >
                <img src={Snapshot_Icon} alt="directory icon"/>
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
          </>
        <div className="footer">
          {["Log Out"].map((label, index) => (
            <ListItemButton key={index} onClick={logout} className="nav-item">
                <LogoutIcon className="footer-icon"/>
              <ListItemText primary={label} />
            </ListItemButton>
          ))}
        </div>
      </List>
    </div>
  );

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="navbar-container" style={{ zIndex: 10 }}>
          {isDataRequestsPage ? (
            <>
              <div className="setting-members" onClick={onArrowBackClick}>
                <ArrowBackIosNewIcon />
              </div>
            </>
          ) : isExternalFormPage ? (
            <>
              <div className="setting-members" onClick={goBacktoDataRequestsPage}>
                <ArrowBackIosNewIcon />
              </div>
            </>
          ): (
            <>
              <div className="setting" onClick={() => setOpen(true)}>
                <DensityMediumIcon />
              </div>
            </>
          )}
          <Drawer open={open} anchor={"left"} onClose={() => setOpen(false)}>
            {list()}
          </Drawer>
        </div>
      </ThemeProvider>
    </>
  );
}

export default Navbar;
